import { ActionCreator, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { ApplicationState } from "../redux/ApplicationState";
import { configUrl } from "../constants/Config";
import { GetCompareNPIDetailsActionDispatchTypes } from "../constants/CompareNPI";
import { GetCompareNPIDetails } from "../services/CompareNPI";
import { CompareNPIDetailsDispatchTypes } from "../models/dispatchTypes/CompareNPI";
import toastType from "../utils/SnackbarProvider";
import { MessageType, ResponseMessages } from "../constants/ResponseMessage";
import { GetExcelDownload } from "../services/Scorecard";
import { ExcelDownloadActionDispatchTypes } from "../models/dispatchTypes/Scorecard";
import { GetExcelActionDispatchTypes } from "../constants/Scorecard";
import { downloadExcelFile } from "../utils";
import { QuarterRange } from "../models/Scorecard";

export const getCompareNPIDetails: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    CompareNPIDetailsDispatchTypes
  >
> = ( userId: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: GetCompareNPIDetailsActionDispatchTypes.GET_COMPARE_NPI_DETAILS_INVOKE,
    });
    const response = await GetCompareNPIDetails(configUrl, userId);

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          dispatch({
            error: response,
            response: null,
            type: GetCompareNPIDetailsActionDispatchTypes.GET_COMPARE_NPI_DETAILS_ERROR,
          });
          toastType.error(ResponseMessages(MessageType.COMPARENPI_FAILURE));
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: GetCompareNPIDetailsActionDispatchTypes.GET_COMPARE_NPI_DETAILS_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const excelDownload: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ExcelDownloadActionDispatchTypes
  >
> = (npi: string, quarterRange: QuarterRange) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: GetExcelActionDispatchTypes.GET_EXCEL_INVOKE,
    });
    const response = await GetExcelDownload(
      configUrl,
      npi,
      quarterRange
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 500:
        case 404:
          toastType.error(ResponseMessages(MessageType.EXCEL_DOWNLOAD_NOT_FOUND));
          break;
        case 200:
        case 201:
          downloadExcelFile(response.data, `Scorecard_excel_${npi}.xlsx`)
          break;
        default:
          break;
      }
    }
  };
};